module.exports = {"330921100":"高亭镇","330921101":"东沙镇","330921102":"岱东镇","330921103":"岱西镇","330921105":"长涂镇","330921106":"衢山镇","330921200":"秀山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330921.json
// module id = 1117
// module chunks = 0